// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../srprsme-react-website/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../srprsme-react-website/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
	FILE: _core.scss

	USED ON:
		- srprs.me/*

	USAGE:
		Meant for 'sitewide' stylesheets aka stylesheets that are needed on every page. Please be careful with this one, don't add unnecessary partials when they're not needed on every page since this slows down the loading/rendering time!!!1!1

	NOTES:
		NEVER use @import "base/*"; or such, read this => http://stackoverflow.com/a/4779432
*/
.clearfix {
  overflow: auto;
}

.display-flex {
  display: inline;
}
@media only screen and (min-width: 767px) {
  .display-flex {
    display: flex;
  }
}

.full-width {
  width: 100%;
}

@media only screen and (max-width: 767px) {
  .mobile-full-width {
    width: 100%;
  }
}

@media only screen and (min-width: 767px) {
  .width-49 {
    width: 49%;
  }
}

.pull-left {
  float: left;
}

.pull-right {
  float: right;
}

.margin-b-s {
  margin-bottom: 10px;
}

.margin-b-m {
  margin-bottom: 20px;
}

.margin-b-l {
  margin-bottom: 40px;
}

.padding-t-s {
  padding-top: 10px;
}

.padding-t-s-7 {
  padding-top: 7px;
}

.padding-l-s {
  padding-left: 10px;
}

.padding-r-s {
  padding-right: 10px;
}

.padding-r-m {
  padding-right: 20px;
}

.padding-r-xl {
  padding-right: 60px;
}

.text-centered {
  text-align: center;
}

.text-bold {
  font-weight: bold;
}

.text-small {
  font-size: 14px;
}

.text-medium {
  font-size: 20px;
}

.text-large {
  font-size: 24px;
}

.text-xlarge {
  font-size: 28px;
}

.text-uppercase {
  text-transform: uppercase;
}

.is-loading,
.loading {
  color: #ececec;
  background-color: #ececec;
}
.is-loading::selection, .is-loading::-moz-selection,
.loading::selection,
.loading::-moz-selection {
  background: #ececec;
}

@media screen and (max-width: ) {
  body:before {
    content: "mobile";
    display: none;
  }
}
@media screen and (min-width: 375px) {
  body::before {
    content: "mobile";
    display: none;
  }
}
@media screen and (min-width: 640px) {
  body::before {
    content: "mobile";
    display: none;
  }
}
@media screen and (min-width: 768px) {
  body::before {
    content: "mobile";
    display: none;
  }
}
@media screen and (min-width: 1024px) {
  body::before {
    content: "mobile";
    display: none;
  }
}
@media screen and (min-width: 1280px) {
  body::before {
    content: "mobile";
    display: none;
  }
}
@media screen and (min-width: 1440px) {
  body::before {
    content: "mobile";
    display: none;
  }
}
@media screen and (min-width: 1600px) {
  body::before {
    content: "mobile";
    display: none;
  }
}
/*
	usage:

	.element {
		@include browserfix(ie) {
			&:after {
				content: "This is IE only"
			}
		}
		@include browserfix(firefox) {
			&:after {
				content: "Only Firefox users will see this";
			}
		}
	}
*/
@keyframes buttonDisabled {
  10%, 90% {
    transform: translate3d(-1px, 0, 0);
  }
  20%, 80% {
    transform: translate3d(2px, 0, 0);
  }
  30%, 50%, 70% {
    transform: translate3d(-4px, 0, 0);
  }
  40%, 60% {
    transform: translate3d(4px, 0, 0);
  }
}
.form-message {
  position: relative;
  box-shadow: 0 0 12px 0 rgba(34, 34, 34, 0.15);
  width: calc(100% - 20px);
  display: inline-block;
  color: #fff;
  position: absolute;
  top: auto;
  bottom: 100%;
  z-index: 999;
  background-color: #1947ba;
  margin-right: 10px;
  margin-bottom: 16px;
  margin-left: 10px;
  padding-top: 20px;
  padding-right: 20px;
  padding-bottom: 20px;
  padding-left: 20px;
}
.form-message:before {
  content: "";
  position: absolute;
  z-index: 1;
  width: 0;
  height: 0;
  border-style: solid;
  bottom: 0;
  left: calc(10% - 12px);
  bottom: -10px;
  border-width: 10px 12px 0 12px;
  border-color: #0000ee transparent transparent transparent;
}
.form-message p {
  line-height: 1.35em;
  font-size: 16px;
  font-weight: 500;
  margin: 0;
}
.form-message > .srprs-icon {
  width: 22px;
  height: 22px;
  position: absolute;
  top: 0;
  left: 0;
  margin-top: 26px;
  margin-left: 20px;
  fill: currentColor;
}
.form-message > .srprs-icon svg {
  width: 100%;
  height: auto;
}
.form-message > .srprs-icon + p, .form-message > .srprs-icon + button + p {
  padding-left: 36px;
}
.form-message > button {
  width: 42px;
  height: 42px;
  line-height: 22px;
  position: absolute;
  cursor: pointer;
  text-align: center;
  transition: all 100ms ease-in-out;
  top: 0;
  right: 0;
  color: currentColor;
  background-color: transparent;
  border-width: 0px;
  padding-top: 10px;
  padding-right: 10px;
  padding-bottom: 10px;
  padding-left: 10px;
}
.form-message > button:hover {
  transform: scale(1.15);
}
.form-message > button:focus {
  outline: 0;
}
.form-message > button svg {
  width: 100%;
  height: auto;
  display: inline-block;
}
.form-message > button svg * {
  fill: currentColor;
}
.form-message > button + p {
  padding-right: 20px;
}
.form-error + .form-message, .form-error + label + .form-message, .form-message.type-error {
  position: relative;
  position: absolute;
  background-color: #eb3a3c;
}
.form-error + .form-message:before, .form-error + label + .form-message:before, .form-message.type-error:before {
  content: "";
  position: absolute;
  z-index: 1;
  width: 0;
  height: 0;
  border-style: solid;
  bottom: 0;
  left: calc(50% - 12px);
  bottom: -10px;
  border-width: 10px 12px 0 12px;
  border-color: #eb3a3c transparent transparent transparent;
}
.form-message.type-info {
  position: relative;
  position: absolute;
  background-color: #1947ba;
}
.form-message.type-info:before {
  content: "";
  position: absolute;
  z-index: 1;
  width: 0;
  height: 0;
  border-style: solid;
  bottom: 0;
  left: calc(50% - 12px);
  bottom: -10px;
  border-width: 10px 12px 0 12px;
  border-color: #1947ba transparent transparent transparent;
}
.form-message.type-note {
  position: fixed;
  left: 0;
  background-color: #eb3a3c;
  margin: 0;
  width: 100%;
}
.form-message.position-fixed {
  position: fixed;
}
.form-message.turquoise {
  color: #222;
  background-color: #1ececa;
}
.form-message.turquoise::before {
  border-top-color: #1ececa !important;
}
.form-message.mint {
  color: #222;
  background-color: #a0ddd2;
}
.form-message.mint::before {
  border-top-color: #a0ddd2 !important;
}
.form-message.green {
  color: #222;
  background-color: #bade94;
}
.form-message.green::before {
  border-top-color: #bade94 !important;
}
.form-message.purple {
  color: #222;
  background-color: #b599c6;
}
.form-message.purple::before {
  border-top-color: #b599c6 !important;
}
.form-message.pink {
  color: #222;
  background-color: #f87498;
}
.form-message.pink::before {
  border-top-color: #f87498 !important;
}
.form-message.blue {
  color: #222;
  background-color: #00a0e0;
}
.form-message.blue::before {
  border-top-color: #00a0e0 !important;
}
.form-message.steel-blue {
  color: #222;
  background-color: #a5bad6;
}
.form-message.steel-blue::before {
  border-top-color: #a5bad6 !important;
}
.form-message.yellow {
  color: #222;
  background-color: #f5ea47;
}
.form-message.yellow::before {
  border-top-color: #f5ea47 !important;
}
.form-message.orange {
  color: #222;
  background-color: #fac56d;
}
.form-message.orange::before {
  border-top-color: #fac56d !important;
}
.form-message.pink-light {
  color: #222;
  background-color: #f0c5ce;
}
.form-message.pink-light::before {
  border-top-color: #f0c5ce !important;
}
.form-message.red {
  color: #222;
  background-color: #f12535;
}
.form-message.red::before {
  border-top-color: #f12535 !important;
}
.form-message.grey {
  color: #222;
  background-color: #d3d3d3;
}
.form-message.grey::before {
  border-top-color: #d3d3d3 !important;
}
.form-message.black {
  color: #222;
  background-color: #222;
}
.form-message.black::before {
  border-top-color: #222 !important;
}
.form-message.white {
  color: #222;
  background-color: #fff;
}
.form-message.white::before {
  border-top-color: #fff !important;
}
.form-message.blue-light {
  color: #222;
  background-color: #aed7e8;
}
.form-message.blue-light::before {
  border-top-color: #aed7e8 !important;
}
.form-message.purple-light {
  color: #222;
  background-color: #cfb9d2;
}
.form-message.purple-light::before {
  border-top-color: #cfb9d2 !important;
}
.form-message.red-light {
  color: #fff;
  background-color: #E7024C;
}
.form-message.red-light::before {
  border-top-color: #E7024C !important;
}
.form-message.tomato {
  color: #fff;
  background-color: #E56159;
}
.form-message.tomato::before {
  border-top-color: #E56159 !important;
}
.form-message.coral {
  color: #222;
  background-color: #F5661C;
}
.form-message.coral::before {
  border-top-color: #F5661C !important;
}
.form-message.tomato-section {
  color: #222;
  background-color: #FF938C;
}
.form-message.tomato-section::before {
  border-top-color: #FF938C !important;
}
.form-message.mint-v2 {
  color: #222;
  background-color: #72BEA5;
}
.form-message.mint-v2::before {
  border-top-color: #72BEA5 !important;
}
.form-message.turquoise-light {
  color: #222;
  background-color: #C2E5ED;
}
.form-message.turquoise-light::before {
  border-top-color: #C2E5ED !important;
}
.form-message.almond {
  color: #222;
  background-color: #F3D5CE;
}
.form-message.almond::before {
  border-top-color: #F3D5CE !important;
}
.form-message.cinderella {
  color: #222;
  background-color: #FDE2DA;
}
.form-message.cinderella::before {
  border-top-color: #FDE2DA !important;
}
.form-message.humming-bird {
  color: #222;
  background-color: #CDF2E6;
}
.form-message.humming-bird::before {
  border-top-color: #CDF2E6 !important;
}
.form-message.golden-tainoi {
  color: #222;
  background-color: #FFCB55;
}
.form-message.golden-tainoi::before {
  border-top-color: #FFCB55 !important;
}
.form-message.pale-turquoise {
  color: #222;
  background-color: #C5EFF4;
}
.form-message.pale-turquoise::before {
  border-top-color: #C5EFF4 !important;
}
.form-message.celadon {
  color: #222;
  background-color: #A7E8BB;
}
.form-message.celadon::before {
  border-top-color: #A7E8BB !important;
}
.form-message.morning-glory {
  color: #222;
  background-color: #91D1DA;
}
.form-message.morning-glory::before {
  border-top-color: #91D1DA !important;
}
.form-message.shalimar {
  color: #222;
  background-color: #F7F5B0;
}
.form-message.shalimar::before {
  border-top-color: #F7F5B0 !important;
}
@media screen and (min-width: 375px) {
  .form-message > .srprs-icon {
    width: 36px;
    height: 36px;
    margin-top: 32px;
    margin-left: 24px;
  }
  .form-message > .srprs-icon + p, .form-message > .srprs-icon + button + p {
    padding-left: 60px;
  }
  .form-message p {
    font-size: 18px;
  }
}
@media screen and (min-width: 640px) {
  .form-message {
    max-width: 650px;
    padding-top: 26px;
    padding-right: 50px;
    padding-bottom: 26px;
    padding-left: 20px;
  }
}
@media screen and (min-width: 768px) {
  .form-message {
    margin-right: 0;
    margin-bottom: 16px;
    margin-left: 0;
    width: auto;
  }
  .form-message.type-error {
    position: relative;
    position: absolute;
  }
  .form-message.type-error:before {
    content: "";
    position: absolute;
    z-index: 1;
    width: 0;
    height: 0;
    border-style: solid;
    bottom: 0;
    left: calc(90px - 12px);
    bottom: -10px;
    border-width: 10px 12px 0 12px;
    border-color: #eb3a3c transparent transparent transparent;
  }
  .form-message.type-error.align-right {
    position: relative;
    position: absolute;
  }
  .form-message.type-error.align-right:before {
    content: "";
    position: absolute;
    z-index: 1;
    width: 0;
    height: 0;
    border-style: solid;
    right: calc(90px - 12px);
    bottom: 0;
    left: auto;
    bottom: -10px;
    border-width: 10px 12px 0 12px;
    border-color: #eb3a3c transparent transparent transparent;
  }
  .form-message.type-info {
    position: relative;
    position: absolute;
  }
  .form-message.type-info:before {
    content: "";
    position: absolute;
    z-index: 1;
    width: 0;
    height: 0;
    border-style: solid;
    bottom: 0;
    left: calc(90px - 12px);
    bottom: -10px;
    border-width: 10px 12px 0 12px;
    border-color: #1947ba transparent transparent transparent;
  }
  .form-message.type-info.align-right {
    position: relative;
    position: absolute;
  }
  .form-message.type-info.align-right:before {
    content: "";
    position: absolute;
    z-index: 1;
    width: 0;
    height: 0;
    border-style: solid;
    right: calc(90px - 12px);
    bottom: 0;
    left: auto;
    bottom: -10px;
    border-width: 10px 12px 0 12px;
    border-color: #1947ba transparent transparent transparent;
  }
  .form-message.type-note {
    position: relative;
    max-width: initial;
    margin-bottom: 20px;
  }
  .form-message.position-fixed {
    position: fixed;
  }
}
@media screen and (min-width: 1024px) {
  .form-message.type-error {
    position: relative;
    position: absolute;
  }
  .form-message.type-error:before {
    content: "";
    position: absolute;
    z-index: 1;
    width: 0;
    height: 0;
    border-style: solid;
    bottom: 0;
    left: calc(100px - 12px);
    bottom: -10px;
    border-width: 10px 12px 0 12px;
    border-color: #eb3a3c transparent transparent transparent;
  }
  .form-message.type-error.align-right {
    position: relative;
    position: absolute;
  }
  .form-message.type-error.align-right:before {
    content: "";
    position: absolute;
    z-index: 1;
    width: 0;
    height: 0;
    border-style: solid;
    right: calc(100px - 12px);
    bottom: 0;
    left: auto;
    bottom: -10px;
    border-width: 10px 12px 0 12px;
    border-color: #eb3a3c transparent transparent transparent;
  }
  .form-message.type-info {
    position: relative;
    position: absolute;
  }
  .form-message.type-info:before {
    content: "";
    position: absolute;
    z-index: 1;
    width: 0;
    height: 0;
    border-style: solid;
    bottom: 0;
    left: calc(100px - 12px);
    bottom: -10px;
    border-width: 10px 12px 0 12px;
    border-color: #1947ba transparent transparent transparent;
  }
  .form-message.type-info.align-right {
    position: relative;
    position: absolute;
  }
  .form-message.type-info.align-right:before {
    content: "";
    position: absolute;
    z-index: 1;
    width: 0;
    height: 0;
    border-style: solid;
    right: calc(100px - 12px);
    bottom: 0;
    left: auto;
    bottom: -10px;
    border-width: 10px 12px 0 12px;
    border-color: #1947ba transparent transparent transparent;
  }
  .form-message.position-fixed {
    position: fixed;
  }
}`, "",{"version":3,"sources":["webpack://./../srprsme-react-components/src/components/_Assets/scss/_core.scss","webpack://./../srprsme-react-components/src/components/_Assets/scss/helpers/_helpers.scss","webpack://./../srprsme-react-components/src/components/FormMessage/FormMessage.scss","webpack://./../srprsme-react-components/src/components/_Assets/scss/helpers/mixins/_breakpoint.scss","webpack://./../srprsme-react-components/src/components/_Assets/scss/helpers/mixins/_browser-fixes.scss","webpack://./../srprsme-react-components/src/components/_Assets/scss/animations/_Button.scss","webpack://./../srprsme-react-components/src/components/_Assets/scss/helpers/mixins/_arrow.scss","webpack://./../srprsme-react-components/src/components/_Assets/scss/helpers/repeatables/_box-shadow.scss"],"names":[],"mappings":"AAEA;;;;;;;;;;;CAAA;ACAA;EACE,cAAA;ACWF;;ADRA;EACE,eAAA;ACWF;ADVE;EAFF;IAGI,aAAA;ECaF;AACF;;ADVA;EACE,WAAA;ACaF;;ADTE;EADF;IAEI,WAAA;ECaF;AACF;;ADTE;EADF;IAEI,UAAA;ECaF;AACF;;ADVA;EACE,WAAA;ACaF;;ADVA;EACE,YAAA;ACaF;;ADVA;EACE,mBAAA;ACaF;;ADVA;EACE,mBAAA;ACaF;;ADVA;EACE,mBAAA;ACaF;;ADVA;EACE,iBAAA;ACaF;;ADVA;EACE,gBAAA;ACaF;;ADVA;EACE,kBAAA;ACaF;;ADVA;EACE,mBAAA;ACaF;;ADVA;EACE,mBAAA;ACaF;;ADVA;EACE,mBAAA;ACaF;;ADVA;EACE,kBAAA;ACaF;;ADVA;EACE,iBAAA;ACaF;;ADXA;EACE,eAAA;ACcF;;ADZA;EACE,eAAA;ACeF;;ADbA;EACE,eAAA;ACgBF;;ADdA;EACE,eAAA;ACiBF;;ADfA;EACE,yBAAA;ACkBF;;ADfA;;EAEE,cAAA;EACA,yBAAA;ACkBF;ADjBE;;;EAEE,mBAAA;ACoBJ;;ACpFA;EAEI;IACE,iBAAA;IACA,aAAA;EDsFJ;AACF;ACvHI;EAwCE;IAcI,iBAAA;IAEF,aAAA;EDoEN;AACF;AC7HI;EAwCE;IAcI,iBAAA;IAEF,aAAA;ED0EN;AACF;ACnII;EAwCE;IAcI,iBAAA;IAEF,aAAA;EDgFN;AACF;ACzII;EAwCE;IAcI,iBAAA;IAEF,aAAA;EDsFN;AACF;AC/II;EAwCE;IAcI,iBAAA;IAEF,aAAA;ED4FN;AACF;ACrJI;EAwCE;IAcI,iBAAA;IAEF,aAAA;EDkGN;AACF;AC3JI;EAwCE;IAcI,iBAAA;IAEF,aAAA;EDwGN;AACF;AEzIA;;;;;;;;;;;;;;;CAAA;AChCA;EACE;IAEE,kCAAA;EH0LF;EGxLA;IAEE,iCAAA;EHyLF;EGvLA;IAGE,kCAAA;EHuLF;EGrLA;IAEE,iCAAA;EHsLF;AACF;AAnMA;EIGE,kBAAA;ECKE,6CAAA;ELLF,wBAAA;EACA,qBAAA;EACA,WAAA;EACA,kBAAA;EACA,SAAA;EACA,YAAA;EACA,YAAA;EAEE,yBAAA;EAGA,kBAAA;EACA,mBAAA;EACA,iBAAA;EAGA,iBAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;AAgMJ;AIlNE;EACE,WAAA;EACA,kBAAA;EACA,UAAA;EACA,QAAA;EACA,SAAA;EAEE,mBAAA;EAkBA,SAAA;EACA,sBAAA;EAOE,aAAA;EAEE,8BAAA;EACA,yDAAA;AJ2LV;AA3ME;EACE,mBAAA;EAEE,eAAA;EACA,gBAAA;EAEF,SAAA;AA2MJ;AAzME;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EAEE,gBAAA;EACA,iBAAA;EAEF,kBAAA;AAyMJ;AAxMI;EACE,WAAA;EACA,YAAA;AA0MN;AAxMI;EAEE,kBAAA;AAyMN;AAtME;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,iCAAA;EACA,MAAA;EACA,QAAA;EACA,mBAAA;EAEE,6BAAA;EAGA,iBAAA;EAGA,iBAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;AAmMN;AAjMI;EACE,sBAAA;AAmMN;AAjMI;EACE,UAAA;AAmMN;AAjMI;EACE,WAAA;EACA,YAAA;EACA,qBAAA;AAmMN;AAlMM;EACE,kBAAA;AAoMR;AAjMI;EACE,mBAAA;AAmMN;AA/LE;EI3FA,kBAAA;EJ+FE,kBAAA;EAEE,yBAAA;AA8LN;AI9RE;EACE,WAAA;EACA,kBAAA;EACA,UAAA;EACA,QAAA;EACA,SAAA;EAEE,mBAAA;EAkBA,SAAA;EACA,sBAAA;EAOE,aAAA;EAEE,8BAAA;EACA,yDAAA;AJuQV;AAxME;EIpGA,kBAAA;EJsGE,kBAAA;EAEE,yBAAA;AAyMN;AIhTE;EACE,WAAA;EACA,kBAAA;EACA,UAAA;EACA,QAAA;EACA,SAAA;EAEE,mBAAA;EAkBA,SAAA;EACA,sBAAA;EAOE,aAAA;EAEE,8BAAA;EACA,yDAAA;AJyRV;AAnNE;EACE,eAAA;EACA,OAAA;EAEE,yBAAA;EAEF,SAAA;EACA,WAAA;AAmNJ;AAjNE;EACE,eAAA;AAmNJ;AA5MI;EACE,WAAA;EACA,yBAAA;AA8MN;AA7MM;EACE,oCAAA;AA+MR;AAnNI;EACE,WAAA;EACA,yBAAA;AAqNN;AApNM;EACE,oCAAA;AAsNR;AA1NI;EACE,WAAA;EACA,yBAAA;AA4NN;AA3NM;EACE,oCAAA;AA6NR;AAjOI;EACE,WAAA;EACA,yBAAA;AAmON;AAlOM;EACE,oCAAA;AAoOR;AAxOI;EACE,WAAA;EACA,yBAAA;AA0ON;AAzOM;EACE,oCAAA;AA2OR;AA/OI;EACE,WAAA;EACA,yBAAA;AAiPN;AAhPM;EACE,oCAAA;AAkPR;AAtPI;EACE,WAAA;EACA,yBAAA;AAwPN;AAvPM;EACE,oCAAA;AAyPR;AA7PI;EACE,WAAA;EACA,yBAAA;AA+PN;AA9PM;EACE,oCAAA;AAgQR;AApQI;EACE,WAAA;EACA,yBAAA;AAsQN;AArQM;EACE,oCAAA;AAuQR;AA3QI;EACE,WAAA;EACA,yBAAA;AA6QN;AA5QM;EACE,oCAAA;AA8QR;AAlRI;EACE,WAAA;EACA,yBAAA;AAoRN;AAnRM;EACE,oCAAA;AAqRR;AAzRI;EACE,WAAA;EACA,yBAAA;AA2RN;AA1RM;EACE,oCAAA;AA4RR;AAhSI;EACE,WAAA;EACA,sBAAA;AAkSN;AAjSM;EACE,iCAAA;AAmSR;AAvSI;EACE,WAAA;EACA,sBAAA;AAySN;AAxSM;EACE,iCAAA;AA0SR;AA9SI;EACE,WAAA;EACA,yBAAA;AAgTN;AA/SM;EACE,oCAAA;AAiTR;AArTI;EACE,WAAA;EACA,yBAAA;AAuTN;AAtTM;EACE,oCAAA;AAwTR;AA5TI;EACE,WAAA;EACA,yBAAA;AA8TN;AA7TM;EACE,oCAAA;AA+TR;AAnUI;EACE,WAAA;EACA,yBAAA;AAqUN;AApUM;EACE,oCAAA;AAsUR;AA1UI;EACE,WAAA;EACA,yBAAA;AA4UN;AA3UM;EACE,oCAAA;AA6UR;AAjVI;EACE,WAAA;EACA,yBAAA;AAmVN;AAlVM;EACE,oCAAA;AAoVR;AAxVI;EACE,WAAA;EACA,yBAAA;AA0VN;AAzVM;EACE,oCAAA;AA2VR;AA/VI;EACE,WAAA;EACA,yBAAA;AAiWN;AAhWM;EACE,oCAAA;AAkWR;AAtWI;EACE,WAAA;EACA,yBAAA;AAwWN;AAvWM;EACE,oCAAA;AAyWR;AA7WI;EACE,WAAA;EACA,yBAAA;AA+WN;AA9WM;EACE,oCAAA;AAgXR;AApXI;EACE,WAAA;EACA,yBAAA;AAsXN;AArXM;EACE,oCAAA;AAuXR;AA3XI;EACE,WAAA;EACA,yBAAA;AA6XN;AA5XM;EACE,oCAAA;AA8XR;AAlYI;EACE,WAAA;EACA,yBAAA;AAoYN;AAnYM;EACE,oCAAA;AAqYR;AAzYI;EACE,WAAA;EACA,yBAAA;AA2YN;AA1YM;EACE,oCAAA;AA4YR;AAhZI;EACE,WAAA;EACA,yBAAA;AAkZN;AAjZM;EACE,oCAAA;AAmZR;AAvZI;EACE,WAAA;EACA,yBAAA;AAyZN;AAxZM;EACE,oCAAA;AA0ZR;AC7hBI;EDyIA;IACE,WAAA;IACA,YAAA;IAEE,gBAAA;IACA,iBAAA;EAsZN;EApZI;IAEE,kBAAA;EAqZN;EAlZE;IAEI,eAAA;EAmZN;AACF;AC3iBI;EDAJ;IA8JM,gBAAA;IAGA,iBAAA;IACA,mBAAA;IACA,oBAAA;IACA,kBAAA;EA+YJ;AACF;ACpjBI;EDAJ;IA0KM,eAAA;IACA,mBAAA;IACA,cAAA;IAEF,WAAA;EA6YF;EA5YE;II5KF,kBAAA;IJ8KI,kBAAA;EA8YJ;EI3jBA;IACE,WAAA;IACA,kBAAA;IACA,UAAA;IACA,QAAA;IACA,SAAA;IAEE,mBAAA;IAkBA,SAAA;IACA,uBAAA;IAOE,aAAA;IAEE,8BAAA;IACA,yDAAA;EJoiBR;EA1ZI;II/KJ,kBAAA;IJiLM,kBAAA;EA4ZN;EI5kBA;IACE,WAAA;IACA,kBAAA;IACA,UAAA;IACA,QAAA;IACA,SAAA;IAEE,mBAAA;IAiCA,wBAAA;IACA,SAAA;IACA,UAAA;IAOE,aAAA;IAEE,8BAAA;IACA,yDAAA;EJsiBR;EAvaE;IIpLF,kBAAA;IJsLI,kBAAA;EAyaJ;EI9lBA;IACE,WAAA;IACA,kBAAA;IACA,UAAA;IACA,QAAA;IACA,SAAA;IAEE,mBAAA;IAkBA,SAAA;IACA,uBAAA;IAOE,aAAA;IAEE,8BAAA;IACA,yDAAA;EJukBR;EArbI;IIvLJ,kBAAA;IJyLM,kBAAA;EAubN;EI/mBA;IACE,WAAA;IACA,kBAAA;IACA,UAAA;IACA,QAAA;IACA,SAAA;IAEE,mBAAA;IAiCA,wBAAA;IACA,SAAA;IACA,UAAA;IAOE,aAAA;IAEE,8BAAA;IACA,yDAAA;EJykBR;EAlcE;IACE,kBAAA;IACA,kBAAA;IAEE,mBAAA;EAmcN;EAhcE;IACE,eAAA;EAkcJ;AACF;AC1oBI;ED4MA;IIzMF,kBAAA;IJ2MI,kBAAA;EAicJ;EI3oBA;IACE,WAAA;IACA,kBAAA;IACA,UAAA;IACA,QAAA;IACA,SAAA;IAEE,mBAAA;IAkBA,SAAA;IACA,wBAAA;IAOE,aAAA;IAEE,8BAAA;IACA,yDAAA;EJonBR;EA7cI;II5MJ,kBAAA;IJ8MM,kBAAA;EA+cN;EI5pBA;IACE,WAAA;IACA,kBAAA;IACA,UAAA;IACA,QAAA;IACA,SAAA;IAEE,mBAAA;IAiCA,yBAAA;IACA,SAAA;IACA,UAAA;IAOE,aAAA;IAEE,8BAAA;IACA,yDAAA;EJsnBR;EA1dE;IIjNF,kBAAA;IJmNI,kBAAA;EA4dJ;EI9qBA;IACE,WAAA;IACA,kBAAA;IACA,UAAA;IACA,QAAA;IACA,SAAA;IAEE,mBAAA;IAkBA,SAAA;IACA,wBAAA;IAOE,aAAA;IAEE,8BAAA;IACA,yDAAA;EJupBR;EAxeI;IIpNJ,kBAAA;IJsNM,kBAAA;EA0eN;EI/rBA;IACE,WAAA;IACA,kBAAA;IACA,UAAA;IACA,QAAA;IACA,SAAA;IAEE,mBAAA;IAiCA,yBAAA;IACA,SAAA;IACA,UAAA;IAOE,aAAA;IAEE,8BAAA;IACA,yDAAA;EJypBR;EArfE;IACE,eAAA;EAufJ;AACF","sourcesContent":["@charset \"UTF-8\";\n\n/*\n\tFILE: _core.scss\n\n\tUSED ON:\n\t\t- srprs.me/*\n\n\tUSAGE:\n\t\tMeant for 'sitewide' stylesheets aka stylesheets that are needed on every page. Please be careful with this one, don't add unnecessary partials when they're not needed on every page since this slows down the loading/rendering time!!!1!1\n\n\tNOTES:\n\t\tNEVER use @import \"base/*\"; or such, read this => http://stackoverflow.com/a/4779432\n*/\n\n// vars & helpers\n@import 'helpers/variables';\n@import 'helpers/helpers';\n\n// functions\n@import 'helpers/functions/map-deep-get';\n@import 'helpers/functions/color';\n@import 'helpers/functions/font';\n//@import \"helpers/functions/padding\";\n@import 'helpers/functions/section';\n@import 'helpers/functions/str-replace';\n@import 'helpers/functions/z-index';\n\n// mixins\n@import 'helpers/mixins/arrow';\n@import 'helpers/mixins/aspect-ratio';\n@import 'helpers/mixins/breakpoint';\n@import 'helpers/mixins/browser-fixes';\n@import 'helpers/mixins/color-schemes';\n@import 'helpers/mixins/grid';\n@import 'helpers/mixins/no-bullets';\n@import 'helpers/mixins/clearfix';\n@import 'helpers/mixins/font-face';\n@import 'helpers/mixins/scrollbars';\n@import 'helpers/mixins/transform-center';\n@import 'helpers/mixins/transition';\n@import 'helpers/mixins/truncate';\n\n// repeatables (aka think DRY and store it in an @mixin)\n@import 'helpers/repeatables/box-shadow';\n@import 'helpers/repeatables/iphonex';\n@import 'helpers/repeatables/wrapper-inner';\n\n// animations\n@import 'animations/Button';\n","@charset \"UTF-8\";\n\n.clearfix {\n  overflow: auto;\n}\n\n.display-flex {\n  display: inline;\n  @media only screen and (min-width: 767px) {\n    display: flex;\n  }\n}\n\n.full-width {\n  width: 100%;\n}\n\n.mobile-full-width {\n  @media only screen and (max-width: 767px) {\n    width: 100%;\n  }\n}\n\n.width-49 {\n  @media only screen and (min-width: 767px) {\n    width: 49%;\n  }\n}\n\n.pull-left {\n  float: left;\n}\n\n.pull-right {\n  float: right;\n}\n\n.margin-b-s {\n  margin-bottom: 10px;\n}\n\n.margin-b-m {\n  margin-bottom: 20px;\n}\n\n.margin-b-l {\n  margin-bottom: 40px;\n}\n\n.padding-t-s {\n  padding-top: 10px;\n}\n\n.padding-t-s-7 {\n  padding-top: 7px;\n}\n\n.padding-l-s {\n  padding-left: 10px;\n}\n\n.padding-r-s {\n  padding-right: 10px;\n}\n\n.padding-r-m {\n  padding-right: 20px;\n}\n\n.padding-r-xl {\n  padding-right: 60px;\n}\n\n.text-centered {\n  text-align: center;\n}\n\n.text-bold {\n  font-weight: bold;\n}\n.text-small {\n  font-size: 14px;\n}\n.text-medium {\n  font-size: 20px;\n}\n.text-large {\n  font-size: 24px;\n}\n.text-xlarge {\n  font-size: 28px;\n}\n.text-uppercase {\n  text-transform: uppercase;\n}\n\n.is-loading,\n.loading {\n  color: #ececec;\n  background-color: #ececec;\n  &::selection,\n  &::-moz-selection {\n    background: #ececec;\n  }\n}\n","$cdn-url: 'https://store.cdn.srprs.me/';\n@charset \"UTF-8\";\n\n@import '../_Assets/scss/core';\n@include color-schemes;\n\n.form-message {\n  @include arrow(bottom, down, 24px, 10px, 10%, color(blue-darker));\n  @include box-shadow();\n  width: calc(100% - 20px);\n  display: inline-block;\n  color: color(white);\n  position: absolute;\n  top: auto;\n  bottom: 100%;\n  z-index: z-index(modal);\n  background: {\n    color: color(info);\n  }\n  margin: {\n    right: 10px;\n    bottom: 16px;\n    left: 10px;\n  }\n  padding: {\n    top: 20px;\n    right: 20px;\n    bottom: 20px;\n    left: 20px;\n  }\n  p {\n    line-height: 1.35em;\n    font: {\n      size: 16px;\n      weight: 500;\n    }\n    margin: 0;\n  }\n  > .srprs-icon {\n    width: 22px;\n    height: 22px;\n    position: absolute;\n    top: 0;\n    left: 0;\n    margin: {\n      top: 26px;\n      left: 20px;\n    }\n    fill: currentColor;\n    svg {\n      width: 100%;\n      height: auto;\n    }\n    & + p,\n    & + button + p {\n      padding-left: 36px;\n    }\n  }\n  > button {\n    width: 42px;\n    height: 42px;\n    line-height: 22px;\n    position: absolute;\n    cursor: pointer;\n    text-align: center;\n    transition: all 100ms ease-in-out;\n    top: 0;\n    right: 0;\n    color: currentColor;\n    background: {\n      color: transparent;\n    }\n    border: {\n      width: 0px;\n    }\n    padding: {\n      top: 10px;\n      right: 10px;\n      bottom: 10px;\n      left: 10px;\n    }\n    &:hover {\n      transform: scale(1.15);\n    }\n    &:focus {\n      outline: 0;\n    }\n    svg {\n      width: 100%;\n      height: auto;\n      display: inline-block;\n      * {\n        fill: currentColor;\n      }\n    }\n    & + p {\n      padding-right: 20px;\n    }\n  }\n\n  .form-error + &,\n  .form-error + label + &,\n  &.type-error {\n    @include arrow(bottom, down, 24px, 10px, 50%, color(error));\n    position: absolute;\n    background: {\n      color: color(error);\n    }\n  }\n  &.type-info {\n    @include arrow(bottom, down, 24px, 10px, 50%, color(info));\n    position: absolute;\n    background: {\n      color: color(info);\n    }\n  }\n  &.type-note {\n    position: fixed;\n    left: 0;\n    background: {\n      color: color(error);\n    }\n    margin: 0;\n    width: 100%;\n  }\n  &.position-fixed {\n    position: fixed;\n  }\n\n  @each $color, $colorBackground, $colorBackgroundAccent, $colorBackgroundTone,\n    $colorForeground, $colorForegroundAccent,\n    $colorForegroundNegative in $list-colorschemes\n  {\n    &.#{\"\" + $color} {\n      color: color($colorForeground);\n      background-color: color($color);\n      &::before {\n        border-top-color: color($color) !important;\n      }\n    }\n  }\n\n  @include breakpoint(mobile-large) {\n    > .srprs-icon {\n      width: 36px;\n      height: 36px;\n      margin: {\n        top: 32px;\n        left: 24px;\n      }\n      & + p,\n      & + button + p {\n        padding-left: 60px;\n      }\n    }\n    p {\n      font: {\n        size: 18px;\n      }\n    }\n  }\n\n  @include breakpoint(mobile-landscape) {\n    max: {\n      width: 650px;\n    }\n    padding: {\n      top: 26px;\n      right: 50px;\n      bottom: 26px;\n      left: 20px;\n    }\n  }\n\n  @include breakpoint(tablet-portrait) {\n    margin: {\n      right: 0;\n      bottom: 16px;\n      left: 0;\n    }\n    width: auto;\n    &.type-error {\n      @include arrow(bottom, down, 24px, 10px, 90px, color(error));\n      position: absolute;\n      &.align-right {\n        @include arrow(bottom-right, down, 24px, 10px, 90px, color(error));\n        position: absolute;\n      }\n    }\n    &.type-info {\n      @include arrow(bottom, down, 24px, 10px, 90px, color(info));\n      position: absolute;\n      &.align-right {\n        @include arrow(bottom-right, down, 24px, 10px, 90px, color(info));\n        position: absolute;\n      }\n    }\n    &.type-note {\n      position: relative;\n      max-width: initial;\n      margin: {\n        bottom: 20px;\n      }\n    }\n    &.position-fixed {\n      position: fixed;\n    }\n  }\n\n  @include breakpoint(tablet-landscape) {\n    &.type-error {\n      @include arrow(bottom, down, 24px, 10px, 100px, color(error));\n      position: absolute;\n      &.align-right {\n        @include arrow(bottom-right, down, 24px, 10px, 100px, color(error));\n        position: absolute;\n      }\n    }\n    &.type-info {\n      @include arrow(bottom, down, 24px, 10px, 100px, color(info));\n      position: absolute;\n      &.align-right {\n        @include arrow(bottom-right, down, 24px, 10px, 100px, color(info));\n        position: absolute;\n      }\n    }\n    &.position-fixed {\n      position: fixed;\n    }\n  }\n}\n","@charset \"UTF-8\";\n\n$breakpoints: map-deep-get($srprsreactwebsite-config, 'breakpoints');\n\n@mixin breakpoint($screensize) {\n  @if map-has-key($breakpoints, $screensize) {\n    @media screen and (min-width: map-get($breakpoints, $screensize)) {\n      @content;\n    }\n  } @else {\n    @media screen and (min-width: #{$screensize}) {\n      @content;\n    }\n  }\n}\n\n$height-breakpoints: map-deep-get(\n  $srprsreactwebsite-config,\n  'height-breakpoints'\n);\n\n@mixin height-breakpoint($screensize) {\n  @if map-has-key($height-breakpoints, $screensize) {\n    @media screen and (max-height: map-get($height-breakpoints, $screensize)) {\n      @content;\n    }\n  } @else {\n    @media screen and (max-height: #{$screensize}) {\n      @content;\n    }\n  }\n}\n\n$breakpoint-initial: map-deep-get(\n  $srprsreactwebsite-config,\n  'breakpoints',\n  's'\n);\n@media screen and (max-width: $breakpoint-initial) {\n  body {\n    &:before {\n      content: 'mobile';\n      display: none;\n    }\n  }\n}\n\n@each $breakpoint, $screensize in $breakpoints {\n  @include breakpoint(#{$screensize}) {\n    body {\n      &::before {\n        @if $breakpoint ==\n          l or\n          $breakpoint ==\n          xl or\n          $breakpoint ==\n          xxl or\n          $breakpoint ==\n          xxxl\n        {\n          content: 'desktop';\n        } @else if $breakpoint == m {\n          content: 'tablet';\n        } @else {\n          content: 'mobile';\n        }\n        display: none;\n      }\n    }\n  }\n}\n","@charset \"UTF-8\";\n\n// we should thank http://browserhacks.com/ for this great roundup of dirt\n\n@mixin browserfix($browser) {\n  @if ($browser == 'ie') {\n    // the allmighty IE, 10 and up. 9 and lower requires usage of conditional comments, just stash your code in assets/styles/ie.scss\n    @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {\n      @content;\n    }\n  } @else if ($browser == 'firefox') {\n    // firefox 3 and up\n    @-moz-document url-prefix() {\n      @content;\n    }\n  } @else if ($browser == 'opera') {\n    // opera 9.5 and up\n    _:-o-prefocus,\n    body:last-child .selector {\n      @content;\n    }\n  } @else if ($browser == 'safari') {\n    // all safari\n    .selector:not(*:root) {\n      @content;\n    }\n  } @else if ($browser == 'chrome') {\n    // chrome 28 and up\n    @supports (-webkit-appearance: none) {\n      @content;\n    }\n  }\n}\n\n/*\n\tusage:\n\n\t.element {\n\t\t@include browserfix(ie) {\n\t\t\t&:after {\n\t\t\t\tcontent: \"This is IE only\"\n\t\t\t}\n\t\t}\n\t\t@include browserfix(firefox) {\n\t\t\t&:after {\n\t\t\t\tcontent: \"Only Firefox users will see this\";\n\t\t\t}\n\t\t}\n\t}\n*/\n","@charset \"UTF-8\";\n\n@keyframes buttonDisabled {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0);\n  }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0);\n  }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0);\n  }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0);\n  }\n}\n","@mixin arrow(\n  $position: top,\n  $direction: down,\n  $width: 20px,\n  $height: 10px,\n  $center: 50%,\n  $color: #000,\n  $pseudo: before\n) {\n  position: relative;\n  &:#{$pseudo} {\n    content: '';\n    position: absolute;\n    z-index: 1;\n    width: 0;\n    height: 0;\n    border: {\n      style: solid;\n    }\n    @if $position == 'top' {\n      top: 0;\n      left: calc(#{$center} - #{$width*0.5});\n      @if $direction == 'up' {\n        top: -$height;\n        border: {\n          width: 0 $width*0.5 $height $width*0.5;\n          color: transparent transparent $color transparent;\n        }\n      } @else if $direction == 'down' {\n        border: {\n          width: $height $width*0.5 0 $width*0.5;\n          color: $color transparent transparent transparent;\n        }\n      }\n    } @else if $position == 'bottom' {\n      bottom: 0;\n      left: calc(#{$center} - #{$width*0.5});\n      @if $direction == 'up' {\n        border: {\n          width: 0 $width*0.5 $height $width*0.5;\n          color: transparent transparent $color transparent;\n        }\n      } @else if $direction == 'down' {\n        bottom: -$height;\n        border: {\n          width: $height $width*0.5 0 $width*0.5;\n          color: $color transparent transparent transparent;\n        }\n      }\n    } @else if $position == 'bottom-right' {\n      right: calc(#{$center} - #{$width*0.5});\n      bottom: 0;\n      left: auto;\n      @if $direction == 'up' {\n        border: {\n          width: 0 $width*0.5 $height $width*0.5;\n          color: transparent transparent $color transparent;\n        }\n      } @else if $direction == 'down' {\n        bottom: -$height;\n        border: {\n          width: $height $width*0.5 0 $width*0.5;\n          color: $color transparent transparent transparent;\n        }\n      }\n    } @else if $position == 'left' {\n      top: calc(#{$center} - #{$width*0.5});\n      @if $direction == 'left' {\n        left: -$height;\n        border: {\n          //width: $height/2 $width $height/2 0;\n          width: $width*0.5 $height $width*0.5 0;\n          color: transparent $color transparent transparent;\n        }\n      } @else if $direction == 'right' {\n        right: -$height;\n        border: {\n          width: $width*0.5 0 $width*0.5 $height;\n          color: transparent transparent transparent $color;\n        }\n      }\n    } @else if $position == 'right' {\n      top: calc(#{$center} - #{$width*0.5});\n      @if $direction == 'left' {\n        right: 0;\n        border: {\n          width: $width*0.5 $height $width*0.5 0;\n          color: transparent $color transparent transparent;\n        }\n      } @else if $direction == 'right' {\n        right: -$height;\n        border: {\n          width: $width*0.5 0 $width*0.5 $height;\n          color: transparent transparent transparent $color;\n        }\n      }\n    }\n  }\n}\n","@charset \"UTF-8\";\n\n$box-shadow: map-deep-get($srprsreactwebsite-config, 'box-shadow');\n\n@mixin box-shadow(\n  $blur: map-deep-get($srprsreactwebsite-config, 'box-shadow', 'blur-default')\n) {\n  @if map-has-key($box-shadow, $blur) {\n    box-shadow: 0\n      0\n      map-deep-get($srprsreactwebsite-config, 'box-shadow', $blur)\n      0\n      rgba(color(black), 0.15);\n  } @else {\n    box-shadow: 0\n      0\n      map-deep-get($srprsreactwebsite-config, 'box-shadow', 'blur-default')\n      0\n      rgba(color(black), 0.15);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
